<template>
  <div class="lc-container">
    <common-search-form-wrapper :reset="handleSearchReset">
      <el-form size="mini" :model="searchInfo" label-width="64px">
        <el-row>
          <el-col :span="8">
            <el-form-item label="班级名称:" prop="class">
              <el-select
                v-model="searchInfo.class_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchClass"
                @focus="handleSearchClass('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in classList"
                  :key="item.class_id"
                  :label="item.name"
                  :value="item.class_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="排课课程:" prop="course_id">
              <el-select
                v-model="searchInfo.course_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchCourse"
                @focus="handleSearchCourse('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.course_id"
                  :label="item.title"
                  :value="item.course_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课教师:" prop="teacher_id">
              <common-staff-pull-down
                :originId.sync="searchInfo.teacher_id"
                :multiple="true"
                :defaultSelected.sync="searchInfo.teacher_list"
                :jobIds="[1]"
                @change="handleSearch"
              ></common-staff-pull-down>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课学员:" prop="student_id">
              <el-select
                v-model="searchInfo.student_id"
                filterable
                clearable
                placeholder="请选择"
                :filter-method="handleSearchStudent"
                @focus="handleSearchStudent('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in studentList"
                  :key="item.student_id"
                  :label="item.name"
                  :value="item.student_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上课教室:" prop="classroom_id">
              <el-select
                v-model="searchInfo.classroom_id"
                filterable
                clearable
                multiple
                placeholder="请选择"
                :filter-method="handleSearchClassroom"
                @focus="handleSearchClassroom('')"
                @change="handleSearch"
              >
                <el-option
                  v-for="item in classroomList"
                  :key="item.classroom_id"
                  :label="item.name"
                  :value="item.classroom_id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="授课模式:" prop="lesson_type">
              <el-radio-group
                v-model="searchInfo.lesson_type"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">线下</el-radio-button>
                <el-radio-button label="2">线上</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="点名状态:" prop="roll_call_status">
              <el-radio-group
                v-model="searchInfo.roll_call_status"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="2">已点名</el-radio-button>
                <el-radio-button label="1">未点名</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="班级类型:" prop="course_type">
              <el-radio-group
                v-model="searchInfo.course_type"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">1vN</el-radio-button>
                <el-radio-button label="2">1v1</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="到课状态:" prop="roll_call_student_status">
              <el-radio-group
                v-model="searchInfo.roll_call_student_status"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">到课</el-radio-button>
                <el-radio-button label="3">请假</el-radio-button>
                <el-radio-button label="4">未到</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8">
            <el-form-item label="课次学员:" prop="student_type">
              <el-radio-group
                v-model="searchInfo.student_type"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">临时</el-radio-button>
                <el-radio-button label="5">体验</el-radio-button>
                <!-- <el-radio-button label="2">调课</el-radio-button> -->
                <el-radio-button label="3">补课</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="课次练习:" prop="lesson_exercise">
              <el-radio-group
                v-model="searchInfo.lesson_exercise"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">已发布</el-radio-button>
                <el-radio-button label="2">未发布</el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="班级人数:"
              prop="class_student_full"
              v-if="Number(searchInfo.course_type) === 1"
            >
              <el-radio-group
                v-model="searchInfo.class_student_full"
                @change="handleSearch"
              >
                <el-radio-button label="-1">全部</el-radio-button>
                <el-radio-button label="1">满班</el-radio-button>
                <el-radio-button label="2">未满班</el-radio-button>
              </el-radio-group>
              <el-popover
                placement="top"
                popper-class="followuppopover"
                trigger="hover"
              >
                <p>班级人数筛选只显示 “1vN”班级的情况</p>
                <i
                  class="el-icon-question"
                  slot="reference"
                  style="margin-left: 8px; color: #bebfc0"
                ></i>
              </el-popover>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </common-search-form-wrapper>
    <div class="lc-header">
      <div class="p6">
        <course-adjustment @courseAdjustment="renderCalendar">
          <div class="float-print-button mwow-button success">快速调课</div>
        </course-adjustment>
      </div>
      <div class="p6" style="left: 85px">
        <del-course-dialog @handleDelCourse="renderCalendar">
          <div class="mwow-button success">删除课次</div>
        </del-course-dialog>
      </div>
      <div class="float-print-wrap">
        <div
          class="float-print-button mwow-button success"
          @click="handleStudentLessonExport"
        >
          导出课次
        </div>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="190"
        >
          <p>
            默认导出本月课表，如需导出其他月，请切换月份时间；筛选条件会影响课表导出的数据；
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: middle;
              margin-right: 15px;
            "
          ></i>
        </el-popover>
      </div>
      <div class="float-print-wrap p7">
        <schedulePrintDialog
          :showTimeRange="showTimeRange"
          :printlnWeek_date="printlnWeek_date"
          :classroom_ids="searchInfo.classroom_id"
        >
          <div class="float-print-button mwow-button success">周课表打印</div>
        </schedulePrintDialog>
        <el-popover
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="190"
        >
          <p>
            默认打印本周课表，如打印其他周，请切换至对应周时间；筛选条件会影响课表打印结果；
          </p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: middle;
            "
          ></i>
        </el-popover>
      </div>
      <range-selector
        range-type="all"
        @change="renderCalendar"
        @update="
          (t) => {
            currentView = t.type;
            timeRange = t.range;
          }
        "
        :show-select="true"
        :start-time="startTime"
        :end-time="endTime"
        :id="1"
      ></range-selector>
    </div>
    <div class="lc-title">
      共{{ dataTotal.total }}课次，已点名{{ dataTotal.signed }}课次，未点名{{
        dataTotal.total - dataTotal.signed
      }}课次, 共{{
        dataTotal.rollcallStudentCount + dataTotal.notRollcallStudentCount || 0
      }}人次, 已点名{{ dataTotal.rollcallStudentCount }}人次,未点名{{
        dataTotal.notRollcallStudentCount
      }}人次
    </div>
    <div class="lc-content" v-loading="loading">
      <div class="tab-wrap" v-show="currentView === 'month'">
        <month-view
          :origin-events="monthEvents"
          @lesson-date-change="openDragDialog"
        >
          <template v-slot:default="slotProps">
            <div
              class="lc-event-month"
              :style="`background-color:${
                slotProps.lesson.roll_call_status === 2
                  ? '#B8B8B8'
                  : slotProps.lesson.course.color
              }`"
              :class="slotProps.lesson.in_holiday === 1 ? 'bias-bgc' : ''"
            >
              <lesson-dialog
                :lid="slotProps.lesson.lesson_id"
                @change="handleDetailUpdate(slotProps.lesson.lesson_id)"
              >
                <div class="lc-event-week">
                  <div class="event-reference">
                    <div class="tag-wrap">
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_student_type.experience > 0
                        "
                        >体</span
                      >
                      <span
                        class="tag"
                        v-if="slotProps.lesson.include_student_type.repair > 0"
                        >补</span
                      >
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_student_type.temporary > 0
                        "
                        >临</span
                      >
                      <span
                        class="tag"
                        v-if="slotProps.lesson.publish_homework === 1"
                        >练</span
                      >
                      <span v-if="slotProps.lesson.roll_call_status === 2">
                        <span
                          class="tag"
                          v-if="
                            slotProps.lesson.include_roll_call_student_status
                              .leave > 0
                          "
                          >假</span
                        >
                        <span
                          class="tag"
                          v-if="
                            slotProps.lesson.include_roll_call_student_status
                              .absent > 0
                          "
                          >未</span
                        >
                        <span
                          class="tag"
                          v-if="
                            slotProps.lesson.include_roll_call_student_status
                              .leave === 0 &&
                            slotProps.lesson.include_roll_call_student_status
                              .absent === 0
                          "
                          >点</span
                        >
                      </span>
                    </div>
                    <p
                      :class="
                        slotProps.lesson.include_student_type.experience > 0 ||
                        slotProps.lesson.include_student_type.repair > 0 ||
                        slotProps.lesson.include_student_type.temporary > 0 ||
                        slotProps.lesson.include_roll_call_student_status
                          .leave > 0 ||
                        slotProps.lesson.include_roll_call_student_status
                          .absent > 0 ||
                        slotProps.lesson.roll_call_status === 2
                          ? 'time pad-top'
                          : 'time'
                      "
                    >
                      {{ slotProps.lesson.start_time.slice(0, 5) }} -
                      {{ slotProps.lesson.end_time.slice(0, 5) }}
                    </p>
                    <p v-if="slotProps.lesson.classroom">
                      {{ slotProps.lesson.classroom.name }}
                    </p>
                    <!-- <p>
                      {{
                        slotProps.lesson.class.name &&
                        slotProps.lesson.class.name
                      }}
                    </p> -->
                    <p>
                      {{
                        slotProps.lesson.class.sub_name
                          ? slotProps.lesson.class.sub_name
                          : slotProps.lesson.class.name
                      }}
                    </p>
                  </div>
                </div>
              </lesson-dialog>
            </div>
          </template>
        </month-view>
      </div>
      <div class="tab-wrap" v-show="currentView === 'week'">
        <week-view
          :origin-events="weekEvents"
          :origin-time-range="showTimeRange"
          @lesson-date-change="openDragDialog"
          class=""
        >
          <template v-slot:default="slotProps">
            <lesson-dialog
              :lid="slotProps.lesson.lesson_id"
              @change="handleDetailUpdate(slotProps.lesson.lesson_id)"
            >
              <div class="lc-event-week">
                <div class="event-reference">
                  <div class="tag-wrap">
                    <span
                      class="tag"
                      v-if="
                        slotProps.lesson.include_student_type.experience > 0
                      "
                      >体</span
                    >
                    <span
                      class="tag"
                      v-if="slotProps.lesson.include_student_type.repair > 0"
                      >补</span
                    >
                    <span
                      class="tag"
                      v-if="slotProps.lesson.include_student_type.temporary > 0"
                      >临</span
                    >
                    <span
                      class="tag"
                      v-if="slotProps.lesson.publish_homework === 1"
                      >练</span
                    >
                    <span v-if="slotProps.lesson.roll_call_status === 2">
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .leave > 0
                        "
                        >假</span
                      >
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .absent > 0
                        "
                        >未</span
                      >
                      <span
                        class="tag"
                        v-if="
                          slotProps.lesson.include_roll_call_student_status
                            .leave === 0 &&
                          slotProps.lesson.include_roll_call_student_status
                            .absent === 0
                        "
                        >点</span
                      >
                    </span>
                  </div>
                  <p
                    :class="
                      slotProps.lesson.include_student_type.experience > 0 ||
                      slotProps.lesson.include_student_type.repair > 0 ||
                      slotProps.lesson.include_student_type.temporary > 0 ||
                      slotProps.lesson.include_roll_call_student_status.leave >
                        0 ||
                      slotProps.lesson.include_roll_call_student_status.absent >
                        0 ||
                      slotProps.lesson.roll_call_status === 2
                        ? 'time pad-top'
                        : 'time'
                    "
                  >
                    {{ slotProps.lesson.start_time.slice(0, 5) }} -
                    {{ slotProps.lesson.end_time.slice(0, 5) }}
                  </p>
                  <p v-if="slotProps.lesson.classroom">
                    {{ slotProps.lesson.classroom.name }}
                  </p>
                  <!-- <p>
                    {{
                      slotProps.lesson.class.name && slotProps.lesson.class.name
                    }}
                  </p> -->
                  <p>
                    {{
                      slotProps.lesson.class.sub_name
                        ? slotProps.lesson.class.sub_name
                        : slotProps.lesson.class.name
                    }}
                  </p>
                  <p
                    v-if="slotProps.lesson.teacher_list.length > 0"
                    class="teacher-name"
                  >
                    {{
                      slotProps.lesson.teacher_list
                        .map((item) => {
                          return item.name;
                        })
                        .join("、")
                    }}
                  </p>
                </div>
              </div>
            </lesson-dialog>
          </template>
        </week-view>
      </div>
      <div class="tab-wrap" v-show="currentView === 'day'">
        <day-view
          :origin-events="dayEvents"
          :origin-time-range="showTimeRange"
          @lesson-date-change="openDragDialog"
        >
          <template v-slot:default="slotProps">
            <lesson-dialog
              :lid="slotProps.lesson.lesson_id"
              @change="handleDetailUpdate(slotProps.lesson.lesson_id)"
            >
              <div class="lc-event-day">
                <p class="time">
                  {{ slotProps.lesson.start_time.slice(0, 5) }} -
                  {{ slotProps.lesson.end_time.slice(0, 5) }}
                </p>
                <p v-if="slotProps.lesson.classroom">
                  {{ slotProps.lesson.classroom.name }}
                </p>
                <p>
                  {{
                    slotProps.lesson.class.sub_name
                      ? slotProps.lesson.class.sub_name
                      : slotProps.lesson.class.name
                  }}
                </p>
                <p v-if="slotProps.lesson.teacher_list.length > 0">
                  {{
                    slotProps.lesson.teacher_list
                      .map((item) => {
                        return item.name;
                      })
                      .join("、")
                  }}
                </p>
                <div v-if="slotProps.lesson.student_list.length > 0">
                  <p
                    v-for="item in slotProps.lesson.student_list"
                    :key="item.student.student_id"
                  >
                    <span v-if="item.student_type === 0">[正]</span>
                    <span v-if="item.student_type === 1">[临]</span>
                    <span v-if="item.student_type === 2">[调]</span>
                    <span v-if="item.student_type === 3">[补]</span>
                    <span v-if="item.student_type === 4">[约]</span>
                    <span v-if="item.student_type === 5">[体]</span>
                    <span>&nbsp; {{ item.student.name }}</span>
                    <span v-if="item.student_status === 0"
                      >&nbsp;-&nbsp;未签到</span
                    >
                    <span v-if="item.student_status === 1"
                      >&nbsp;-&nbsp;到课</span
                    >
                    <span v-if="item.student_status === 2"
                      >&nbsp;-&nbsp;迟到</span
                    >
                    <span v-if="item.student_status === 3"
                      >&nbsp;-&nbsp;请假</span
                    >
                    <span v-if="item.student_status === 4"
                      >&nbsp;-&nbsp;未到</span
                    >
                  </p>
                </div>
              </div>
            </lesson-dialog>
          </template>
        </day-view>
      </div>
    </div>
    <!-- 拖拽调课 -->
    <el-dialog
      title="调课 - 课时修改提醒"
      :visible.sync="dragDialogVisible"
      destroy-on-close
      append-to-body
      width="465px"
    >
      <div class="drag-dialog-wrap">
        <div class="item">
          <p class="title">原课时</p>
          <div class="content">
            <p>{{ dragDialogData.date }}</p>
            <p>
              {{ dragDialogData.start_time.slice(0, 5) }}-{{
                dragDialogData.end_time.slice(0, 5)
              }}
            </p>
            <p>{{ dragDialogData.teacherStr }}</p>
            <p>{{ dragDialogData.class.name }}</p>
          </div>
        </div>
        <i class="arrow el-icon-d-arrow-right"></i>
        <div class="item">
          <p class="title">修改后课时</p>
          <div class="content">
            <p class="mwow-green">{{ dragDialogData.new_date }}</p>
            <p class="mwow-green">
              {{ dragDialogData.new_start_time.slice(0, 5) }}-{{
                dragDialogData.new_end_time.slice(0, 5)
              }}
            </p>
            <p>{{ dragDialogData.teacherStr }}</p>
            <p>{{ dragDialogData.class.name }}</p>
          </div>
        </div>
      </div>
      <div class="drag-dialog-btns">
        <div class="mwow-button-filled mini" @click="hideDragDialog">取消</div>
        <div class="mwow-button-filled success mini" @click="handleDragSubmit">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import {
  getSelectClassList,
  getSelectCourseList,
  searchStudent,
} from "@/api/globalSearch";
import {
  lessonDetail,
  getRange,
  timetableTotalApi,
  timeTable,
} from "@/api/schedule";
import { editLessonTime } from "@/api/lesson";
import { exportLessonScheduleApi } from "@/api/export";
import { exportLoop } from "@/utils/export";
import lessonDialog from "../lessonDialog.vue";
import rangeSelector from "./rangeSelector.vue";
import monthView from "./monthView.vue";
import weekView from "./weekView.vue";
import dayView from "./dayView.vue";
import { dateFormat, getCurrentMonth } from "@/utils/timeFormat";
import { PageModule } from "@/store/module/page";
import { classroomSelectListApi } from "@/api/classRoom";
import { mixin } from "@/mixin/tabPageInfoMixin";
import delCourseDialog from "@/components/delCourseDialog.vue";
import courseAdjustment from "@/components/courseAdjustment.vue";
import schedulePrintDialog from "@/components/schedulePrintDialog.vue";
import commonStaffPullDown from "@/components/commonStaffPullDown.vue";
import commonSearchFormWrapper from "@/components/commonSearchFormWrapper.vue";

export default {
  name: "lessonCalendar",
  components: {
    rangeSelector,
    monthView,
    weekView,
    dayView,
    lessonDialog,
    delCourseDialog,
    courseAdjustment,
    schedulePrintDialog,
    commonStaffPullDown,
    commonSearchFormWrapper,
  },
  mixins: [mixin],
  props: [
    "cid",
    "tid",
    "tname",
    "dayViewTime",
    "startTime",
    "endTime",
    "visible",
  ],
  data() {
    return {
      searchInfo: {
        sub_name: "",
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        classroom_id: [],
        teacher_id: [],
        teacher_list: [],
        lesson_exercise: "-1",
      },
      delCourseVisible: false,
      setNum: 5,
      showFormText: "展开",
      classList: [],
      SubClassList: [],
      courseClass: {},
      courseList: [],
      studentList: [],
      teacherList: [],
      timeRange: [],
      currentView: "week",
      monthEvents: [],
      weekEvents: [],
      dayEvents: [],
      classroomList: [],
      dataTotal: {
        total: 0,
        signed: 0,
        rollcallStudentCount: 0,
        notRollcallStudentCount: 0,
      },
      currentDialogLessonData: {
        class: {},
        class_lesson_extend: {
          content: "-",
        },
      },
      lessonCache: {},
      dragDialogVisible: false,
      dragDialogData: {
        start_time: "",
        end_time: "",
        new_start_time: "",
        new_end_time: "",
        class: {},
      },
      showTimeRange: [],
      loading: false,
      printlnWeek_date: "", // 存起来的开始和结束时间
      printlnWeek_start: "", // 存起来的开始和结束时间
      printlnWeek_end: "", // 存起来的开始和结束时间
      rules: {
        week_date: [
          { required: true, message: "请选择周时间", trigger: "change" },
        ],
      },
    };
  },
  mounted() {
    this.mixinGetPageInfo("timeTableSearch");
    if (this.cid) {
      this.searchInfo.classroom_id = [this.cid];
    }
    if (this.tid) {
      this.searchInfo.teacher_id = [this.tid];
      if (this.tname) {
        this.searchInfo.teacher_list = [
          {
            name: this.tname,
            staff_id: this.tid,
          },
        ];
      }
    }
    eventBus.$on("schedule-range-change", (arr) => {
      this.showTimeRange = arr;
      this.renderCalendar();
    });
    eventBus.$on("to-teacher-go-time-day-view", (data) => {
      eventBus.$emit("schecule-switch-to-day-view", data.full);
      return;
    });
    // 来自首页
    if (PageModule.latestRoute === "dashboard") {
      if (this.$route.params.linkType === "to-day-view") {
        eventBus.$emit(
          "schecule-switch-to-day-view",
          dateFormat("YYYY-mm-dd", new Date().getTime())
        );
      }
    }
    if (this.dayViewTime !== "") {
      eventBus.$emit("schecule-switch-to-day-view", this.dayViewTime);
    }
    const unwatch = this.$watch("visible", (n) => {
      if (n) {
        this.init();
      }
      this.$nextTick(() => {
        unwatch();
      });
    });
    if (this.visible) {
      this.init();
    }
  },
  beforDestroy() {
    eventBus.$off("schedule-range-change");
  },
  methods: {
    init() {
      if (this.searchInfo.className) {
        this.handleSearchClass(this.searchInfo.className);
      }
      if (this.searchInfo.courseName) {
        this.handleSearchCourse(this.searchInfo.courseName);
      }
      if (this.searchInfo.studentName) {
        this.handleSearchStudent(this.searchInfo.studentName);
      }
      if (this.searchInfo.classroomName) {
        this.handleSearchClassroom(this.searchInfo.classroomName);
      }
      getRange().then((res) => {
        if (res.error_code === 0) {
          if (res.data.end_time === "00:00:00") {
            res.data.end_time = "23:55:00";
          }
          this.showTimeRange = [res.data.start_time, res.data.end_time];
          this.renderCalendar();
        }
      });
    },
    handleStudentLessonExport() {
      const params = this.handleSearchOptions();
      if (this.currentView === "month") {
        const year = Number(params.start_date.slice(0, 4));
        let month = Number(params.start_date.slice(5, 7));
        const day = Number(params.start_date.slice(8, 10));
        month = day === 1 ? month : month + 1;
        const newRange = getCurrentMonth(year + "/" + month + "/1");
        params.start_date = dateFormat("YYYY-mm-dd", newRange[0]);
        params.end_date = dateFormat("YYYY-mm-dd", newRange[1]);
      }
      delete params.simplify;
      exportLessonScheduleApi(params).then((res) => {
        // 数量可能很大，轮询间隔长一点
        exportLoop(res.data.task_id, 1000);
        this.$message({
          type: "success",
          message: "导出中，请稍候",
        });
      });
    },
    handleSearchReset() {
      this.searchInfo = {
        lesson_type: "-1",
        roll_call_status: "-1",
        course_type: "-1",
        class_student_full: "-1",
        student_type: "-1",
        roll_call_student_status: "-1",
        classroom_id: [],
        teacher_id: [],
        lesson_exercise: "-1",
      };
      this.mixinSavePageInfo("timeTableSearch");
      this.renderCalendar();
    },
    // 时间格式化
    formatTime(time) {
      const date = new Date(time);
      const y = date.getFullYear();
      const m = date.getMonth() + 1;
      const d = date.getDate();
      return `${y}-${m < 10 ? "0" + m : m}-${d < 10 ? "0" + d : d}`;
    },
    handleSearchClassroom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classroomList = res.data.list;
        }
      });
      this.searchInfo.classroomName = v;
    },
    handleSearchClass(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.classList = res.data.list;
        }
      });
      this.searchInfo.className = v;
    },
    handleSearchClassBySub(v) {
      getSelectClassList({
        page: 1,
        page_size: 50,
        sub_name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          res.data.list.forEach((item) => {
            // 旧数据的班级没有 sub_name，默认使用 name 代替
            if (item.sub_name === "") {
              item.sub_name = item.name;
            }
          });
          this.SubClassList = res.data.list;
        }
      });
      this.searchInfo.class_sub = v;
    },
    handleSearchClassBySubVisible(rest) {
      if (rest) {
        this.handleSearchClassBySub("");
      }
    },
    handleSearchCourse(v) {
      getSelectCourseList({
        page: 1,
        page_size: 50,
        title: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.courseList = res.data.list;
        }
      });
      this.searchInfo.courseName = v;
    },
    handleSearchStudent(v) {
      searchStudent({
        page: 1,
        page_size: 50,
        key_word: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.studentList = res.data.list;
        }
      });
      this.searchInfo.studentName = v;
    },
    handleSearch() {
      this.renderCalendar();
      this.mixinSavePageInfo("timeTableSearch");
    },
    // 处理搜索参数
    handleSearchOptions(data) {
      const searchTime = data ? data.range : this.timeRange;
      let start =
        this.startTime !== "" ? this.startTime : this.formatTime(searchTime[0]);
      let end =
        this.endTime !== "" ? this.endTime : this.formatTime(searchTime[1]);
      if (data && data.type && data.range) {
        this.currentView = data.type;
        this.timeRange = data.range;
      }
      const params = {
        start_date: start,
        end_date: end,
      };
      if (this.searchInfo.course_id) {
        params.course_ids = [this.searchInfo.course_id];
      }
      if (this.searchInfo.class_id) {
        params.class_ids = [this.searchInfo.class_id];
      }
      // 使用简称过滤班级名称，再用班级名称查询表格数据
      if (this.searchInfo.class_sub) {
        params.class_ids = [this.searchInfo.class_sub];
      }
      if (this.searchInfo.teacher_id.length > 0) {
        params.teacher_ids = this.searchInfo.teacher_id;
      }
      if (this.searchInfo.student_id) {
        params.student_ids = [this.searchInfo.student_id];
      }
      if (Number(this.searchInfo.lesson_type) >= 0) {
        params.lesson_type = Number(this.searchInfo.lesson_type);
      }
      if (Number(this.searchInfo.roll_call_status) >= 0) {
        params.roll_call_status = Number(this.searchInfo.roll_call_status);
      }
      if (Number(this.searchInfo.course_type) >= 0) {
        params.course_type = Number(this.searchInfo.course_type);
        if (Number(this.searchInfo.course_type) === 1) {
          if (Number(this.searchInfo.class_student_full) >= 0) {
            params.class_student_full = Number(
              this.searchInfo.class_student_full
            );
          }
        }
      }
      if (Number(this.searchInfo.student_type) >= 0) {
        params.student_type = Number(this.searchInfo.student_type);
      }
      if (Number(this.searchInfo.roll_call_student_status) >= 0) {
        params.roll_call_student_status = Number(
          this.searchInfo.roll_call_student_status
        );
      }
      if (
        this.searchInfo.classroom_id &&
        this.searchInfo.classroom_id.length > 0
      ) {
        params.classroom_ids = this.searchInfo.classroom_id;
      }
      if (Number(this.searchInfo.lesson_exercise) > 0) {
        params.publish_homework = Number(this.searchInfo.lesson_exercise);
      }
      params.simplify = this.currentView === "month";
      return params;
    },
    // 渲染日历
    renderCalendar(data) {
      let cache = JSON.parse(sessionStorage.getItem("cacheMonth"));
      if (!data && cache) {
        data = cache;
      }
      if (!this.visible) {
        return false;
      }
      const searchView = data ? data.type : this.currentView;
      const params = this.handleSearchOptions(data);
      if (params.start_date) {
        this.printlnWeek_date = params.start_date;
        this.printlnWeek_start = params.start_date;
      }
      if (params.end_date) {
        this.printlnWeek_end = params.end_date;
      }
      this.loading = true;
      timeTable(params)
        .then((res) => {
          this.loading = false;
          // 统计点名课次，月视图有邻近数据，需要特殊处理
          if (searchView === "month") {
            let curYear = Number(params.start_date.slice(0, 4));
            let curMonth = Number(params.start_date.slice(5, 7));
            const curDay = Number(params.start_date.slice(8, 10));
            if (curDay > 1) {
              curMonth = curMonth + 1;
              if (curMonth === 13) {
                curMonth = 1;
                curYear = curYear + 1;
              }
            }
            const newRange = getCurrentMonth(curYear + "/" + curMonth + "/1");
            params.start_date = dateFormat("YYYY-mm-dd", newRange[0]);
            params.end_date = dateFormat("YYYY-mm-dd", newRange[1]);
            timetableTotalApi(params).then((result) => {
              this.dataTotal = {
                total:
                  result.data.not_roll_call_count + result.data.roll_call_count,
                signed: result.data.roll_call_count,
                rollcallStudentCount: result.data.roll_call_student_count,
                notRollcallStudentCount:
                  result.data.not_roll_call_student_count,
              };
            });
          } else {
            this.dataTotal = {
              total: res.data.total,
              signed: res.data.roll_call_count,
              rollcallStudentCount: res.data.roll_call_student_count,
              notRollcallStudentCount: res.data.not_roll_call_student_count,
            };
          }
          if (searchView === "month") {
            this.monthEvents = res.data.date_list;
          }
          if (searchView === "week") {
            this.weekEvents = res.data.date_list;
          }
          if (searchView === "day") {
            this.dayEvents = res.data.date_list;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getLessonInfo(lesson) {
      const id = lesson.lesson_id;
      // 课次信息缓存
      if (this.lessonCache[id]) {
        this.currentDialogLessonData = this.lessonCache[id];
        this.courseClass = this.lessonCache[id].class;
      } else {
        lessonDetail({
          lesson_id: id,
        }).then((res) => {
          this.courseClass = res.data.class;
          const arr = [];
          const arr1 = [];
          const arr3 = [];
          const arr4 = [];
          if (lesson.roll_call_status === 2) {
            res.data.roll_call_student_list.map((item) => {
              if (item.student_status === 1) {
                arr1.push(item.student.name);
              }
              if (item.student_status === 2) {
                arr1.push(item.student.name);
              }
              if (item.student_status === 3) {
                arr3.push(item.student.name);
              }
              if (item.student_status === 4) {
                arr4.push(item.student.name);
              }
            });
          } else {
            res.data.student_list.map((item) => {
              arr.push(item.name);
            });
          }
          lesson.class.current_student_count =
            res.data.class.current_student_count;
          lesson.class.preset_student_count =
            res.data.class.preset_student_count;
          const result = {
            ...res.data,
            studentString: arr.join(","),
            studentString1: arr1.join(","),
            studentString3: arr3.join(","),
            studentString4: arr4.join(","),
          };
          this.currentDialogLessonData = result;
          if (result.class_lesson_extend.content) {
            this.currentDialogLessonData.class_lesson_extend.content =
              result.class_lesson_extend.content;
          }
          this.lessonCache[id] = result;
        });
      }
    },
    toRollCall(rid, lid) {
      if (!rid) {
        this.$router.push({
          name: "classTimeDetails",
          query: { id: String(lid) },
        });
      } else {
        this.$router.push({
          name: "rollCallDetails",
          query: { id: String(rid) },
        });
      }
    },
    handleDetailUpdate(lid) {
      // 课次详情更新后删除详情缓存，重新渲染表格
      const copy = { ...this.lessonCache };
      delete copy[lid];
      this.lessonCache = copy;
      this.renderCalendar();
    },
    openDragDialog(data) {
      this.dragDialogVisible = true;
      const week = ["日", "一", "二", "三", "四", "五", "六"];
      data.week = `（周${
        week[new Date(data.date.replace(/-/g, "/")).getDay()]
      }）`;
      data.new_week = `（周${
        week[new Date(data.new_date.replace(/-/g, "/")).getDay()]
      }）`;
      data.teacherStr = data.teacher_list
        .map((item) => {
          return item.name;
        })
        .join(",");
      this.dragDialogData = data;
    },
    hideDragDialog() {
      this.dragDialogVisible = false;
    },
    handleDragSubmit() {
      const params = { ...this.dragDialogData };
      editLessonTime({
        lesson_id: params.lesson_id,
        start_time: params.new_start_time.slice(0, 5) + ":00",
        end_time: params.new_end_time.slice(0, 5) + ":00",
        date: params.new_date,
      })
        .then((res) => {
          this.$message({
            type: "success",
            message: "修改成功",
          });
          this.hideDragDialog();
          this.renderCalendar();
        })
        .catch(() => {
          this.hideDragDialog();
          this.renderCalendar();
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.lc-container {
  background: #ffffff;
  .form-wrap {
    position: relative;
  }
  .lc-header {
    margin-bottom: 12px;
    position: relative;
    .p6 {
      margin-top: 5px;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .float-print-wrap {
      position: absolute;
      bottom: 0;
      left: 170px;
      margin-top: 5px;
    }
    .p7 {
      left: 275px !important;
      display: flex;
      align-items: center;
    }
  }
  .lc-title {
    margin-bottom: 12px;
    height: 28px;
    background: #fff7e9;
    border-radius: 4px;
    font-size: 12px;
    line-height: 28px;
    color: #5c5d5e;
    padding: 0 10px;
  }
  .lc-content {
    .tab-wrap {
      height: 100%;
    }
    .lc-event-month {
      font-size: 12px;
      color: #fff;
      line-height: 18px;
      margin-bottom: 3px;
      position: relative;
      .tag-wrap {
        position: absolute;
        top: 0;
        left: 0;
        .tag {
          display: inline-block;
          vertical-align: top;
          font-size: 12px;
          line-height: 12px;
          padding: 4px 3px;
          background-color: #888888;
          border-bottom-left-radius: 20%;
          border-bottom-right-radius: 20%;
          transform: scale(0.8);
          transform-origin: right top;
        }
      }
      .time {
        padding-right: 24px;
      }
      p {
        line-height: 18px;
        text-align: left;
        overflow: hidden;
      }
      .el-popover__reference {
        padding: 3px 8px;
      }
    }
    .lc-event-week,
    .lc-event-day {
      margin-bottom: 5px;
      height: 100%;
      font-size: 12px;
      color: #fff;
      line-height: 16px;
      padding: 3px 8px;
      cursor: pointer;
      position: relative;
      // .event-reference {
      //   height: 100%;
      //   box-sizing: border-box;
      //   padding: 3px 8px;
      //   position: relative;
      //   border-right: 1px solid #eee;
      //   border-bottom: 1px solid #eee;
      // }
      .tag-wrap {
        position: absolute;
        top: 0;
        left: 0;
        .tag {
          display: inline-block;
          vertical-align: top;
          font-size: 12px;
          line-height: 12px;
          padding: 4px 3px;
          background-color: #888888;
          border-bottom-left-radius: 20%;
          border-bottom-right-radius: 20%;
          transform: scale(0.8);
          transform-origin: right top;
        }
      }
      .time {
        padding-right: 24px;
      }
      p {
        line-height: 18px;
        text-align: left;
        overflow: hidden;
      }
    }
    .lc-event-week {
    }
  }
}
.event-hover-dialog {
  margin: -12px;
  .content {
    padding: 12px;
    color: #5c5d5e;
    .p1 {
      font-size: 13px;
      line-height: 22px;
      span {
        vertical-align: baseline;
      }
      img {
        vertical-align: middle;
        margin-left: 6px;
      }
      .roll-tag {
        vertical-align: baseline;
        background-color: #888888;
        border-radius: 4px;
        color: #fff;
        font-size: 12px;
        line-height: 12px;
        padding: 2px 4px;
        margin-left: 10px;
      }
    }
    .p2 {
      font-size: 12px;
      line-height: 22px;
      border-top: 1px solid #cbcbcb;
      padding-top: 8px;
      margin-top: 4px;
    }
  }
  .btns {
    display: flex;
    .btn {
      flex: 1;
      line-height: 30px;
      text-align: center;
      font-size: 12px;
      cursor: pointer;
      &.green {
        color: #07d1aa;
        background: #f0fdfa;
      }
      &.gray {
        color: #5c5d5e;
        background: #f1f1f1;
      }
      &.blue {
        color: #32bdf3;
        background: #eaf8fd;
      }
    }
  }
}
.drag-dialog-shadow {
  z-index: 1000;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
}
.drag-dialog-wrap {
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #5c5d5e;
  padding: 0 49px 20px 49px;
  .item {
    flex: 1;
    .title {
      margin-bottom: 12px;
    }
    .content {
      border-radius: 4px;
      padding: 12px;
      line-height: 24px;
      border: 1px solid #e7e8ea;
    }
  }
  .arrow {
    padding-top: 24px;
    font-size: 14px;
    margin: 0 12px;
  }
}
.drag-dialog-btns {
  text-align: right;
  .mwow-button-filled {
    margin-left: 10px;
  }
}
.dot {
  &::after {
    content: ",";
  }
  &:last-child {
    &::after {
      display: none;
    }
  }
}

.p3 {
  font-size: 12px;
  line-height: 22px;
  border-top: 1px solid #cbcbcb;
  padding-top: 4px;
  margin-top: 4px;
}
/deep/.el-form {
  .el-form-item {
    margin-right: 38px;
    .el-select {
      width: 100%;
      .el-select__tags {
        width: 100%;
        display: flex;
        max-width: 161px;
        flex-wrap: nowrap;
        overflow-x: auto;
        &::-webkit-scrollbar {
          width: 4px;
          height: 1px;
        }
        &::-webkit-scrollbar-track {
          width: 4px;
          background: none;
        }
        &::-webkit-scrollbar-thumb {
          width: 4px;
          background: #d8d8d8;
          border-radius: 2px;
        }
      }
    }
  }
}
.p5 {
  display: flex;
  font-size: 13px;
  span {
    flex: 1;
  }
}
.xian {
  height: 1px;
  background-color: #d7d7d7;
}
/deep/ .el-dialog .el-dialog__footer {
  border-top: none;
}
.statistics {
  height: 70px;
  line-height: 70px;
  border-bottom: 1px solid #d7d7d7;
}
.resetting {
  position: absolute !important;
  top: 49px !important;
  right: 0 !important;
}
.teacher-name {
  white-space: pre-wrap;
  max-width: 260px;
}
.pad-top {
  padding-top: 12px;
}
</style>
